import { SitemapStoreAction, SitemapStoreType } from './sitemapStore.types';

export const INITIAL_SITEMAP = { items: [] };

const sitemapStore = (
  state: SitemapStoreType,
  action: SitemapStoreAction
): SitemapStoreType => {
  switch (action.type) {
    case 'INITIAL': {
      return {
        ...state,
        items: action.payload,
      };
    }
    default:
      throw new Error();
  }
};

export default sitemapStore;
